import { render, staticRenderFns } from "./EnterMarksSheet.vue?vue&type=template&id=6eb21b3b&scoped=true"
import script from "./EnterMarksSheet.vue?vue&type=script&lang=js"
export * from "./EnterMarksSheet.vue?vue&type=script&lang=js"
import style0 from "./EnterMarksSheet.vue?vue&type=style&index=0&id=6eb21b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb21b3b",
  null
  
)

export default component.exports